import React from "react";
import styles from "./button.module.scss";

const ExternalLink = ({ href, children, title, className }) => (
  <a href={href} title={title} rel="noopener noreferrer" target="_blank" className={styles[className]}>
    {children}
  </a>
);

export default ExternalLink;
